import { forwardRef } from 'react'

import { AnimationSheet } from '@/components/detail/components/shared/animationSheet/view'
import AppBanner from '@/components/detail/components/shared/banner/view'
import ParkinglotDetailHeaderView from '@/components/detail/components/shared/header/view'
import ParkinglotInfoView from '@/components/detail/components/shared/parkinglotInfo/view'
import StaticNaverMap from '@/components/map/components/staticNaverMap'
import SharedParkinglotSummary from '@/components/map/components/summary/SharedParkinglotSummary'
import PurchaseClientView from '@/components/purchase/view'
import RecommendParkinglotView from '@/components/recommendParkinglot/view'
import type { ParkinglotWithDistance } from '@/components/recommendParkinglot/viewModel'

import type { SharedParkinglotDetail } from '@/api/server/detail/dto/detailDto'
import Shared from '@/shared'
import Footer from '@/shared/components/Footer'
import type { MotionValue } from 'framer-motion'
import type { LegacyRef } from 'react'

import { SHEET_STATE_TYPE } from '@/enums/detail'

interface SharedParkinglotProps {
  pin: SharedParkinglotDetail
  isRoadViewOpen: boolean
  setIsRoadViewOpen: React.Dispatch<React.SetStateAction<boolean>>
  sortedParkinglots: ParkinglotWithDistance[]
  sheetType: SHEET_STATE_TYPE
  sheetPositionY: MotionValue<number>
}

const SharedParkinglot = forwardRef((props: SharedParkinglotProps, ref: LegacyRef<HTMLDivElement>) => {
  const { pin, isRoadViewOpen, setIsRoadViewOpen, sortedParkinglots, sheetType, sheetPositionY } = props
  const globalIsPurchase = Shared.States.useIsPurchase((state) => state.isPurchase)

  return (
    <>
      <AnimationSheet sheetType={sheetType} sheetPositionY={sheetPositionY}>
        <div ref={ref}>
          {sheetType === SHEET_STATE_TYPE.VISIBLE && (
            <>
              <ParkinglotDetailHeaderView parkinglotName={pin.basic.name} parkinglotSeq={pin.seq} />
              <div className="relative -mt-[56px] h-[170px] w-full">
                <StaticNaverMap lat={pin.basic.latitude} lng={pin.basic.longitude} />
              </div>
            </>
          )}
          <SharedParkinglotSummary
            sheetType={sheetType}
            pin={pin}
            setIsRoadViewOpen={setIsRoadViewOpen}
            isRoadViewOpen={isRoadViewOpen}
          />
          {sortedParkinglots.length > 0 && <RecommendParkinglotView sortedParkinglots={sortedParkinglots} />}
          <ParkinglotInfoView pin={pin} />
          <AppBanner
            parkinglotSeq={pin.seq}
            latitude={pin.basic.latitude}
            longitude={pin.basic.longitude}
            type={pin.type}
          />
          <Footer />
        </div>
      </AnimationSheet>
      {globalIsPurchase && <PurchaseClientView data={pin} />}
    </>
  )
})

SharedParkinglot.displayName = 'SharedParkinglot'

export default SharedParkinglot
